var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGenericWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6387_23434)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 47,
    fill: "white",
    stroke: "url(#paint0_linear_6387_23434)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1495 63.1198C69.4595 64.3098 68.2295 65.0298 66.8595 65.0298H29.1395C27.7695 65.0298 26.5395 64.3198 25.8495 63.1398C25.1595 61.9498 25.1595 60.5298 25.8495 59.3398L44.7095 26.6498C45.3995 25.4598 46.6295 24.7598 47.9995 24.7598C49.3695 24.7598 50.5895 25.4698 51.2695 26.6498L70.1295 59.3398C70.8195 60.5198 70.8195 61.9398 70.1295 63.1198H70.1495Z",
    fill: "#F4F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9695 57.6398L52.9595 26.4298C51.9295 24.6398 50.0795 23.5798 48.0195 23.5698C45.9495 23.5698 44.0995 24.6398 43.0595 26.4298L25.0495 57.6398C24.0095 59.4298 24.0095 61.5698 25.0495 63.3598C26.0795 65.1498 27.9395 66.2198 30.0095 66.2198H66.0395C68.1095 66.2198 69.9595 65.1498 70.9995 63.3498C72.0295 61.5598 72.0295 59.4198 70.9995 57.6398H70.9695ZM69.1495 62.3098C68.4895 63.4498 67.3195 64.1298 66.0095 64.1298H29.9895C28.6795 64.1298 27.4995 63.4498 26.8495 62.3198C26.1895 61.1898 26.1995 59.8298 26.8495 58.6898L44.8595 27.4798C45.5195 26.3498 46.6895 25.6698 47.9995 25.6698C49.3095 25.6698 50.4795 26.3498 51.1295 27.4698L69.1495 58.6798C69.7995 59.8098 69.7995 61.1598 69.1495 62.2898V62.3098Z",
    fill: "#5D3FDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5995 54.45C47.4795 54.48 47.3495 54.5 47.2295 54.57C47.1095 54.62 46.9995 54.67 46.8895 54.75C46.7895 54.82 46.6795 54.89 46.5895 55C46.2095 55.37 45.9995 55.89 45.9995 56.41C45.9995 56.93 46.2195 57.45 46.5895 57.82C46.6795 57.91 46.7895 57.99 46.8895 58.07C46.9895 58.15 47.1095 58.21 47.2295 58.25C47.3495 58.3 47.4795 58.34 47.5995 58.37C47.7295 58.4 47.8495 58.41 47.9795 58.41C48.4995 58.41 49.0195 58.19 49.3995 57.82C49.7795 57.44 49.9895 56.95 49.9895 56.41C49.9895 55.87 49.7695 55.37 49.3995 55C48.9295 54.53 48.2495 54.32 47.5995 54.45Z",
    fill: "#5D3FDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9995 51.5399C48.9795 51.5399 49.7595 50.7599 49.7795 49.7599V37.9699C49.7795 36.9899 48.9795 36.1899 47.9995 36.1899C47.0195 36.1899 46.2195 36.9899 46.2195 37.9699V49.7599C46.2195 50.7399 47.0195 51.5399 47.9995 51.5399Z",
    fill: "#5D3FDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6387_23434",
    x1: 14.3999,
    y1: 14.3999,
    x2: 81.3,
    y2: 81.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D3FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23D0C5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6387_23434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericWarning);
export default __webpack_public_path__ + "static/media/generic_warning.499f117ab2ce6f26d9f9e3c18f9e1d00.svg";
export { ForwardRef as ReactComponent };